import { memo } from 'react';
import { useGetCommonStore } from '@/store';
import { BenefitItem } from './components/BenefitItem';
import { ScBenefitsSection } from './styled';

export const BenefitsSection = memo(() => {
  const useCommonStore = useGetCommonStore();
  const vip = useCommonStore.use.vip();

  if (!vip?.benefits?.length) return null;

  return (
    <ScBenefitsSection>
      {vip.benefits.map((benefit) => (
        <BenefitItem
          description={benefit.description}
          imgUrl={benefit.image?.url ?? ''}
          key={benefit.id}
          subTitle={benefit.subTitle}
          title={benefit.title}
        />
      ))}
    </ScBenefitsSection>
  );
});

BenefitsSection.displayName = 'BenefitsSection';
